import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import {
    HttpHandler, HttpEvent, HttpInterceptor,
    HttpRequest, HttpResponse, HttpErrorResponse
} from "@angular/common/http";
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/take';
import 'rxjs/add/observable/throw';

@Injectable()
export class AuthResponseInterceptor implements HttpInterceptor {

    // Indica se c'è un refresh del token già in corso
    isRefreshingToken: boolean = false;

    // Questo Subject funge da "semaforo": trasmette il nuovo token a tutte le richieste in coda
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    auth: AuthService;

    constructor(
        private injector: Injector,
        private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.auth = this.injector.get(AuthService);

        return next.handle(request)
            .catch(error => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    return this.handle401Error(request, next);
                } else {
                    return Observable.throw(error);
                }
            });
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {

        if (!this.isRefreshingToken) {

            this.isRefreshingToken = true;

            // Reset del subject così le chiamate successive aspetteranno
            this.refreshTokenSubject.next(null);

            return this.auth.refreshToken()
                .switchMap((res: any) => {
                    this.isRefreshingToken = false;

                    const newToken = this.auth.getAuth()!.token;

                    // Notifica a tutte le richieste "appese" che il token è pronto
                    this.refreshTokenSubject.next(newToken);

                    // Riesegue la richiesta originale che aveva scatenato il 401
                    return next.handle(this.addToken(request, newToken));
                })
                .catch(error => {
                    this.isRefreshingToken = false;
                    this.auth.logout();
                    this.router.navigate(["login"]);
                    return Observable.throw(error);
                });

        }
        else {
            // Se il refresh è già in corso, questa richiesta si mette "in coda"
            return this.refreshTokenSubject
                .filter(token => token != null) // Aspetta finché il token non viene emesso
                .take(1) // Prende il primo valore valido e chiude lo stream
                .switchMap(token => {
                    // Riesegue la richiesta con il nuovo token ricevuto dal subject
                    return next.handle(this.addToken(request, token));
                });
        }
    }

    // Metodo helper per clonare la richiesta con il nuovo header
    private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }

}


// WEBPACK FOOTER //
// ./ClientApp/app/_services/auth.response.interceptor.ts